import { Link } from 'react-router-dom';
import { v4 as uuid4 } from 'uuid';
import { PATH } from '../../constants';
import { HStack } from '../layouts/stack.layout';
import Text from '../typography/v2/text';

export function TagsContainer(props: { tags?: string[] }) {
  const { tags } = props;
  return (
    <>
      {tags && (
        <HStack gap="sm" wrap="wrap">
          {tags.map((tag) => (
            <Link key={uuid4()} to={`/${PATH.DISCOVER}?q=${tag}`}>
              <Text variant="tag" text={tag} />
            </Link>
          ))}
        </HStack>
      )}
    </>
  );
}
